import {useCallback, useState} from 'react'

export function useLoadedData() {
  const getLoadedData = useCallback(
    (
      page: string | number | undefined,
      limit: string | number | undefined,
      totalData: number
    ): {
      startLoad: number
      endLoad: number
    } => {
      let loadedPage = 1
      if (typeof page === 'string') {
        loadedPage = parseInt(page) || 1
      }

      if (typeof page === 'number') {
        loadedPage = page || 1
      }

      let loadedLimit = 10
      if (typeof limit === 'string') {
        loadedLimit = parseInt(limit) || 1
      }

      if (typeof limit === 'number') {
        loadedLimit = limit || 10
      }

      const startItem = (loadedPage - 1) * loadedLimit + 1
      const endItem = Math.min(loadedPage * loadedLimit, totalData)

      return {
        startLoad: startItem,
        endLoad: endItem,
      }
    },
    []
  )

  const [loadedData, setLoadedData] = useState<{
    startLoad: number
    endLoad: number
  }>({
    startLoad: 0,
    endLoad: 0,
  })

  return {
    calculate: getLoadedData,
    loadedData,
    setLoadedData,
  }
}
